<form class="itinerary-model-content-inner" *ngIf="packageForm" [formGroup]="packageForm">
  <div class="itinerary-model-content">
    <div class="form-container">
      <!-- Users Details start -->
      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">CRM / Website Builder Subscription details</ion-title>
      </div>

      <div class="row ion-padding-horizontal">
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Subscription Start Date*</label>
            <div [ngClass]="{ 'invalid-input': packageForm.get('startDate')?.invalid && packageForm.get('startDate')?.touched }">
              <app-date-picker [maxDate]="convertToDate(packageForm.get('endDate')?.value)" formControlName="startDate"></app-date-picker>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Subscription End Date*</label>
            <div [ngClass]="{ 'invalid-input': packageForm.get('endDate')?.invalid && packageForm.get('endDate')?.touched }">
              <app-date-picker [minDate]="convertToDate(packageForm.get('startDate')?.value)" formControlName="endDate"></app-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="ion-no-padding mt-1">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Select A CRM Plan</ion-title>
      </div>

      <!-- Error if neither selected -->
      <div class="error-message ion-padding-horizontal" *ngIf="packageForm.get('packageIds')?.invalid && packageForm.get('packageIds')?.touched">
        Please select at least one package (CRM or Website Builder)
      </div>

      <div class="packages-container ion-padding-horizontal py-2" *ngIf="allPackagesDetails">
        <div class="row">
          <div class="col-4 mb-1" *ngFor="let package of allPackagesDetails; index as i">
            <div class="card" [ngClass]="{'selected-package': selectedPackages.crm === package}">
              <div class="header">{{package.packageName}}</div>
              <div class="features">
                <p class="key-title">Key Feature</p>
                <ul class="features-list">
                  <li *ngFor="let module of package?.modules">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>  {{module.text}}
                  </li>
                </ul>
              </div>
              <div class="pricing">
                <p>Starting From</p>
                <ul>
                  <li *ngFor="let price of package.pricing">
                    <ng-container *ngIf="price.maxUsers > 0">
                      Upto {{price.maxUsers}} Users {{price.pricePerUserPerMonth | currency : price.currency}} per month / biilled annually
                    </ng-container>
                    <ng-container  *ngIf="price.maxUsers === 0">
                      For 5 and above users {{price.pricePerUserPerMonth | currency : price.currency}} per month / billed annually
                    </ng-container>
                    <ng-container *ngIf="price.maxUsers === -1">
                      For Unlimited Users {{price.pricePerUserPerMonth | currency : price.currency}} per year / biilled annually
                    </ng-container>
                  </li>
                </ul>
              </div>
              <div class="select-button">
                <button type="button" (click)="selectPackage(package, 'crm')" *ngIf="!isUserEditing">
                  {{ selectedPackages.crm === package ? 'Selected' : 'Select' }}
                </button>
                <button type="button" *ngIf="selectedPackages.crm === package && isUserEditing">
                  Selected
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Select A Website Builder Plan</ion-title>
      </div>

      <div class="packages-container ion-padding-horizontal py-2" *ngIf="websiteBuilderPackages">
        <div class="row">
          <div class="col-4 mb-1" *ngFor="let package of websiteBuilderPackages; index as i">
            <div class="card" [ngClass]="{'selected-package': selectedPackages.websiteBuilder === package}">
              <div class="header">{{package.packageName}}</div>
              <div class="features">
                <p class="key-title">Key Feature</p>
                <ul class="features-list">
                  <li *ngFor="let module of package?.modules">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>  {{module.text}}
                  </li>
                </ul>
              </div>
              <div class="pricing">
                <p>Starting From</p>
                <ul>
                  <li *ngFor="let price of package.pricing">
                    <ng-container *ngIf="price.maxUsers > 0">
                      Upto {{price.maxUsers}} Users {{price.pricePerUserPerMonth | currency : price.currency}} per month / biilled annually
                    </ng-container>
                    <ng-container  *ngIf="price.maxUsers === 0">
                      For 5 and above users {{price.pricePerUserPerMonth | currency : price.currency}} per month / billed annually
                    </ng-container>
                    <ng-container *ngIf="price.maxUsers === -1">
                      For Unlimited Users {{price.pricePerUserPerMonth | currency : price.currency}} per year / biilled annually
                    </ng-container>
                  </li>
                </ul>
              </div>
              <div class="select-button">
                <button type="button" (click)="selectPackage(package, 'websiteBuilder')" *ngIf="!isUserEditing">
                  {{ selectedPackages.websiteBuilder === package ? 'Selected' : 'Select' }}
                </button>
                <button type="button" *ngIf="selectedPackages.websiteBuilder === package && isUserEditing">
                  Selected
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


